// FloatingVue gives us <VDropdown> for anchored popovers used in the
// calendar grid (#290). Theming is overridden in calendar styles to
// match the Stemne cream/ink design system rather than the default.
//
// `stemne-popover-inline` renders the popper next to its trigger instead of
// teleporting it to <body>, so a menu opened inside a modal stays inside the
// modal's focus trap. It lives here rather than as `:container="false"` on the
// component because floating-vue's published typings mistype that prop as
// `Date`, so the (runtime-valid) `false` fails vue-tsc. Theme config is resolved
// at runtime and carries no such typing. Without `$resetCss` the popper keeps
// the parent `v-popper--theme-stemne-popover` class too.
export const floatingVueOptions = {
  themes: {
    'stemne-popover': {
      $extend: 'dropdown',
      $resetCss: true,
    },
    'stemne-popover-inline': {
      $extend: 'stemne-popover',
      container: false,
    },
  },
}
